/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import {MultiCodeEditorInteractive} from 'components/markdown/MultiCodeEditorInteractive';
import {Type, TypeContainer} from 'components/markdown/Type';
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    ul: "ul",
    li: "li",
    strong: "strong",
    code: "code",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "Type: ", React.createElement(TypeContainer, null, React.createElement(Type, {
    children: "<string>"
  }), " | ", React.createElement(Type, {
    children: "<string[]>"
  })), React.createElement("br"), "\nDefault: ", React.createElement(Type, {
    children: "'auto'"
  }), React.createElement("br"), "\nValues: ", React.createElement(TypeContainer, null, React.createElement(Type, {
    children: "'load'"
  }), " | ", React.createElement(Type, {
    children: "'domcontentloaded'"
  }), " | ", React.createElement(Type, {
    children: "'networkidle0'"
  }), " | ", React.createElement(Type, {
    children: "'networkidle2'"
  }))), "\n", React.createElement(_components.p, null, "Tell the browser to wait until the target website emits one or more event(s) to consider navigation succeeded."), "\n", React.createElement(_components.p, null, "The events that can be waited are:"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(_components.strong, null, "auto"), ": A smart combination of ", React.createElement(_components.code, null, "'load'"), " and ", React.createElement(_components.code, null, "'networkidle2'"), "."), "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event"
  }, React.createElement(_components.strong, null, "load")), ": It considers navigation successful when the whole page, including all dependent resources such as stylesheets images, have been loaded. In certain cases, it might not happen at all."), "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event"
  }, React.createElement(_components.strong, null, "domcontentloaded")), ": It's fired as soon as the page DOM has been loaded, without waiting for resources to finish loading."), "\n", React.createElement(_components.li, null, React.createElement(_components.strong, null, "networkidle0"), ": It considers navigation successful when the page has had no network activity for half a second. This might never happen if the page is constantly loading multiple resources."), "\n", React.createElement(_components.li, null, React.createElement(_components.strong, null, "networkidle2"), ": It considers navigation successful when the page has no more then 2 network requests for half a second. This is useful if page runs a long polling in the background."), "\n"), "\n", React.createElement(MultiCodeEditorInteractive, {
    mqlCode: {
      url: 'https://dev.to',
      screenshot: true,
      waitUntil: 'domcontentloaded'
    }
  }), "\n", React.createElement(_components.p, null, "Different arguments work for different pages. When neither of them work, a good solution would be to navigate with ", React.createElement(Type, {
    children: "'domcontentloaded'"
  }), " argument and then simply wait for the needed element to appear on page."), "\n", React.createElement(MultiCodeEditorInteractive, {
    mqlCode: {
      url: 'https://dev.to',
      screenshot: true,
      waitUntil: 'domcontentloaded',
      waitForSelector: 'h1'
    }
  }));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
